/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { HighlightSegment } from './highlightSegment';

/**
 * Output of feedback component: Highlighting
 */
export interface HighlightingOutput {
  [key: string]: HighlightSegment[];
}
